import React from "react";
// import { makeStyles } from "@material-ui/core/styles";
import Popper from "@material-ui/core/Popper";
// import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Fade from "@material-ui/core/Fade";
import Paper from "@material-ui/core/Paper";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";

export default function MoreOption(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const { deleteList, setEditModal, setDetailModal } = props;

  const handleClick = event => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popper" : undefined;

  return (
    <div>
      <Button aria-describedby={id} variant="text" onClick={handleClick}>
        <MoreVertIcon />
      </Button>
      <Popper id={id} open={open} anchorEl={anchorEl} transition>
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <Paper onMouseLeave={handleClick}>
              <List component="nav" aria-label="main list edit">
                <ListItem button dense={true} onClick={() => setDetailModal(true)}>
                  <ListItemText primary="Details" />
                </ListItem>
                <ListItem button dense={true} onClick={() => setEditModal(true)}>
                  <ListItemText primary="Edit" />
                </ListItem>
                <ListItem button dense={true} onClick={deleteList}>
                  <ListItemText primary="Delete" />
                </ListItem>
              </List>
            </Paper>
          </Fade>
        )}
      </Popper>
    </div>
  );
}
